<script setup lang="ts">
import * as lucideIcons from "lucide-vue-next";
import type { LucideIcon } from "lucide-vue-next";
import { twMerge } from "tailwind-merge";
import { computed, useAttrs, type SVGAttributes } from "vue";

type LucideImport = typeof lucideIcons;
export type Icon = Exclude<keyof LucideImport, "createLucideIcon" | "default" | "icons" | "Icon">;

interface LucideProps extends /* @vue-ignore */ SVGAttributes {
  icon: Icon;
  title?: string;
}

const props = defineProps<LucideProps>();

const attrs = useAttrs();
const iconComponents: Record<Icon, LucideIcon> = Object.fromEntries(
  Object.entries(lucideIcons).filter(([key, value]) =>
    Object.prototype.hasOwnProperty.call(lucideIcons, key) &&
    typeof value === "function" &&
    !["createLucideIcon", "default", "icons", "Icon"].includes(key)
  )
) as Record<Icon, LucideIcon>;

const computedClass = computed(() =>
  twMerge([
    "stroke-[1] w-5 h-5",
    typeof attrs.class === "string" && attrs.class,
  ])
);
</script>

<template>
  <component
    :is="iconComponents[props.icon]"
    v-bind="attrs"
    :class="computedClass"
  />
</template>
